<nb-card status="{{ status() }}">
  <nb-card-header>
    {{ quiz.title }}
    <button
      class="close"
      nbButton
      hero
      status="primary"
      size="small"
      (click)="close()"
    >
      <nb-icon icon="close-outline"></nb-icon>
    </button>
  </nb-card-header>

  <nb-card-body [nbSpinner]="loading" nbSpinnerStatus="info">
    <ngx-view-quiz [quiz]="quiz"> </ngx-view-quiz>
  </nb-card-body>

  <nb-card-footer *ngIf="!loading">
    <button
      nbButton
      hero
      shape="semi-round"
      status="success"
      (click)="submit()"
      [disabled]="submitted"
      [class.btn-pulse]="submitted"
      *ngIf="!this.quiz.submitted"
    >
      <nb-icon icon="done-all-outline"></nb-icon>
      Gửi đáp án
    </button>

    <button
      nbButton
      outline
      shape="semi-round"
      status="info"
      (click)="reload()"
      [disabled]="submitted"
      [class.btn-pulse]="submitted"
      *ngIf="this.quiz.submitted"
    >
      <nb-icon icon="refresh-outline"></nb-icon>
      Thử lại
    </button>
  </nb-card-footer>
</nb-card>
